import { resourceQueryOptions } from "@/api/resources";
import { queryClient } from "@/api/utils";
import { QueryHandler } from "@givenwell/components";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { fallback, object, optional, string } from "valibot";
import { ArticlePage } from "./ArticlePage";
import { AudioPage } from "./AudioPage";
import { VideoPage } from "./VideoPage";

export const Route = createFileRoute("/_auth/_app/resources/$resourceId")({
  validateSearch: object({
    from: fallback(optional(string()), undefined),
  }),
  loader: ({ params: { resourceId } }) => {
    queryClient.prefetchQuery(resourceQueryOptions(resourceId));
  },
  component: ResourcePage,
});

const route = getRouteApi("/_auth/_app/resources/$resourceId");

function ResourcePage() {
  const { resourceId } = route.useParams();

  const query = useQuery(resourceQueryOptions(resourceId));

  return (
    <QueryHandler
      query={query}
      success={({ data: resource }) => (
        <>
          {resource.type === "article" && <ArticlePage resource={resource} />}
          {resource.type === "audio" && <AudioPage resource={resource} />}
          {resource.type === "video" && <VideoPage resource={resource} />}
        </>
      )}
    />
  );
}
